import { useRoleCheck } from '@utils/hooks/useRoleCheck';
import { ReactNode } from 'react';
import { Role } from './RolePermissionConfig';

type RoleGateProps = {
  roles: Role[];
  children: ReactNode;
};

const PermissionGate = ({ roles, children }: RoleGateProps) => {
  const allowed = useRoleCheck(roles);
  if (allowed) return <>{children}</>;
  return undefined;
};

export default PermissionGate;
